import { Record, fromJS } from 'immutable';
class PhoneValidationConfigureResponse extends Record({
  isValid: null,
  geoPermission: null
}) {}
export function fromJSON(obj) {
  return new PhoneValidationConfigureResponse(fromJS(obj));
}
export default PhoneValidationConfigureResponse;